import { Card, Callout, Switch, useToast } from "@gf/ui";
import { useSaveSetting, useSettings } from "./useSettings";

export function PauseAlerts() {
  const settings = useSettings();
  const save = useSaveSetting<Record<string, unknown>>("notifications");
  const toast = useToast();
  const raw = settings.data && "notifications" in settings.data ? settings.data.notifications : undefined;
  const notifications = raw && typeof raw === "object" && !Array.isArray(raw) ? raw as Record<string, unknown> : {};
  async function change(enabled: boolean) {
    try {
      await save.mutateAsync({ ...notifications, pauseEmail: enabled });
      toast.success(enabled ? "Pause emails enabled" : "Pause emails turned off");
    } catch (err) { toast.error(err); }
  }
  return <Card title="Pause notifications" subtitle="Get an email when Instagram causes a new automation pause, with the reason, end time, and next steps.">
    <Switch label="Email me when automation pauses" labelPosition="start"
      description="Sent to your GramFather account email. This preference saves immediately."
      checked={notifications.pauseEmail !== false} disabled={settings.isPending || settings.isError || save.isPending}
      onChange={(enabled) => void change(enabled)} />
    {save.isError ? <Callout tone="danger" title="Couldn't save your notification preference">Try the switch again.</Callout> : null}
  </Card>;
}
